import "core-js/modules/es.array.every";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.reduce";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.object.values";
import "core-js/modules/es.string.includes";
import "core-js/modules/web.dom-collections.for-each";
import _Message2 from "element-ui/lib/theme-chalk/message.css";
import "element-ui/lib/theme-chalk/base.css";
import _Message from "element-ui/lib/message";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import { getStationOilDiscountCounter } from '@/api/bairun/financialCenter';
import moment from 'moment';
import NP from 'number-precision';
import dateUtils from '@/utils/dateUtil';
export default {
  name: 'FinancialDiffPrice',
  data: function data() {
    var _this = this;

    return {
      datePickerValue: [(dateUtils.todayTimestamp() - 7 * 24 * 60 * 60) * 1000, (dateUtils.todayTimestamp() - 24 * 60 * 60) * 1000],
      downloadLoading: false,
      selectedArea: '全部',
      filterMapping: [{
        text: '佛山',
        value: '佛山'
      }, {
        text: '粤西',
        value: '粤西'
      }, {
        text: '外省',
        value: '外省'
      }],
      borderFix: ['合计/L', '合/L', '总均价', '平台优惠'],
      cellColClassFix: ['dayNums', 'daySumDiscount', 'dayDiffDiscountPrice', 'dayDiffDiscountPrice92', 'dayDiffDiscountPrice95', 'dayDiffDiscountPrice0'],
      stationDailyDiscountData: [],
      tempGroupData: {},
      sheetUnLoadCount: 1,
      showStations: [],
      excelSheets: [{
        tableId: 'stationDailyDiscountData',
        name: '油品优惠价差报表',
        tableRows: 2
      }],
      pickerOptionsLimit: {
        disabledDate: function disabledDate(pTime) {
          return _this.userInfo.authorityId === '888' ? false : pTime.getTime() < new Date() - 91 * 86400 * 1000 || pTime.getTime() > new Date() - 86400 * 1000;
        }
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters('user', ['userInfo'])), mapGetters('stations', ['asyncStations'])),
  updated: function updated() {
    var _this2 = this;

    this.$nextTick(function () {
      _this2.$refs['stationDailyDiscountData'].doLayout(); // console.log('refsUpdate')

    });
  },
  methods: {
    cellStyle: function cellStyle(_ref) {
      var row = _ref.row,
          column = _ref.column;

      if (this.borderFix.includes(column.label)) {
        return 'border-right:1px solid #000000';
      }

      if (this.cellColClassFix.includes(column.property)) {
        return 'background: #ffe9cf';
      }
    },
    filterChange: function filterChange(selected) {
      this.selectedArea = selected['area'] && selected['area'][0] ? selected['area'][0] : '全部';
    },
    filterHandler: function filterHandler(value, row, column) {
      for (var i in this.asyncStations) {
        if (this.asyncStations[i]['ID'] === row['sellerId'] && this.asyncStations[i]['statArea'] === value) {
          return true;
        }
      }

      return false;
    },
    getSummaries: function getSummaries(param) {
      var columns = param.columns,
          data = param.data;
      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }

        var values = data.map(function (item) {
          return Number(item[column.property]);
        });

        if (!values.every(function (value) {
          return isNaN(value);
        })) {
          sums[index] = values.reduce(function (prev, curr) {
            var value = Number(curr);

            if (!isNaN(value)) {
              return NP.plus(prev, curr);
            } else {
              return prev;
            }
          }, 0);
          sums[index] = NP.round(sums[index], 2);
        } else {
          sums[index] = 'N/A';
        }
      });
      sums[3] = sums[1] > 0 ? NP.round(NP.divide(sums[2], sums[1]), 2) : '-';
      sums[6] = sums[4] > 0 ? NP.round(NP.divide(sums[5], sums[4]), 2) : '-';
      sums[13] = sums[11] > 0 ? NP.round(NP.divide(sums[12], sums[11]), 2) : '-';
      sums[20] = sums[18] > 0 ? NP.round(NP.divide(sums[19], sums[18]), 2) : '-';
      return sums;
    },
    sellerName: function sellerName(sellerId) {
      for (var i in this.asyncStations) {
        if (this.asyncStations[i].ID === sellerId) {
          return this.asyncStations[i]['statAbbr'];
        }
      }

      return '';
    },
    loadData: function loadData() {
      var _this3 = this;

      if (this.downloadLoading) {
        return;
      }

      this.downloadLoading = true;
      var descriptorData = {
        descriptors: [{
          type: 'ocosotpc',
          operator: 'dateOCOSOTPC',
          t: 555,
          name: 'StationOilDiscountCounter',
          start: this.datePickerValue[0] / 1000,
          end: this.datePickerValue[1] / 1000,
          search: ''
        }]
      };
      getStationOilDiscountCounter(descriptorData).then(function (response) {
        var tmpGroupData = Object.values(response.data).sort(function (a, b) {
          var orders = [10006, 10003, 10011, 10013, 10010, 10014, 10001, 10012, 10002, 10005, 10004, 10009, 10008, 10015]; // // console.log('sort orders', orders.indexOf(a.sellerId), orders.indexOf(b.sellerId))

          return orders.indexOf(a.sellerId) - orders.indexOf(b.sellerId);
        });

        var retObj = _this3.groupDataFilter(tmpGroupData); // console.log('retObj', retObj)


        _this3.stationDailyDiscountData = Object.values(retObj).sort(function (a, b) {
          var orders = [10006, 10003, 10011, 10013, 10010, 10014, 10001, 10012, 10002, 10005, 10004, 10009, 10008, 10015]; // console.log('sort orders', orders.indexOf(a.sellerId), orders.indexOf(b.sellerId))

          return orders.indexOf(a.sellerId) - orders.indexOf(b.sellerId);
        }); // console.log('this.stationDailyDiscountData', this.stationDailyDiscountData)

        _this3.downloadLoading = false;
        _this3.sheetUnLoadCount = 0;

        _this3.$refs['stationDailyDiscountData'].doLayout();
      }).catch(function () {
        _this3.downloadLoading = false;
      });
    },
    groupDataFilter: function groupDataFilter(data) {
      var obj = {};
      data.forEach(function (el) {
        var tmpObj = {
          'sellerId': 0,
          'dayNums': 0,
          'dayCapitalAmount': 0,
          'daySumDiscount': 0,
          'dayDiffDiscountPrice': 0,
          'dayNums92': 0,
          'daySumDiscount92': 0,
          'dayDiffDiscountPrice92': 0,
          'daySumExtraDiscount92': 0,
          'daySumUserDiscount92': 0,
          'daySumSvcDiscount92': 0,
          'daySumPlatformDiscount92': 0,
          'dayNums95': 0,
          'daySumDiscount95': 0,
          'dayDiffDiscountPrice95': 0,
          'daySumExtraDiscount95': 0,
          'daySumUserDiscount95': 0,
          'daySumSvcDiscount95': 0,
          'daySumPlatformDiscount95': 0,
          'dayNums0': 0,
          'daySumDiscount0': 0,
          'dayDiffDiscountPrice0': 0,
          'daySumExtraDiscount0': 0,
          'daySumUserDiscount0': 0,
          'daySumSvcDiscount0': 0,
          'daySumPlatformDiscount0': 0
        };

        if (!obj[el.sellerId]) {
          var extraDiscount = NP.round(NP.times(el.monthNums, NP.minus(el.monthGoodsOriginal, el.monthGoodsPrice)), 2);
          tmpObj['sellerId'] = el.sellerId;
          tmpObj['dayNums'] = el.monthNums;
          tmpObj['dayCapitalAmount'] = el.monthCapitalAmount;
          tmpObj['daySumDiscount'] = NP.round(NP.plus(el.monthSumUserDiscount, el.monthSumSvcDiscount, el.monthSumPlatformDiscount, extraDiscount, -el.monthCapitalAmount), 2);
          tmpObj['dayDiffDiscountPrice'] = tmpObj['dayNums'] === 0 ? 0 : NP.round(NP.divide(tmpObj['daySumDiscount'], tmpObj['dayNums']), 2);
          tmpObj['dayNums' + el.oilCode] = el.monthNums;
          tmpObj['daySumDiscount' + el.oilCode] = NP.round(NP.plus(el.monthSumUserDiscount, el.monthSumSvcDiscount, el.monthSumPlatformDiscount, extraDiscount), 2);
          tmpObj['dayDiffDiscountPrice' + el.oilCode] = el.monthNums === 0 ? 0 : NP.round(NP.divide(NP.plus(el.monthSumUserDiscount, el.monthSumSvcDiscount, el.monthSumPlatformDiscount, extraDiscount), el.monthNums), 2);
          tmpObj['daySumExtraDiscount' + el.oilCode] = extraDiscount || 0;
          tmpObj['daySumUserDiscount' + el.oilCode] = el.monthSumUserDiscount || 0;
          tmpObj['daySumSvcDiscount' + el.oilCode] = el.monthSumSvcDiscount || 0;
          tmpObj['daySumPlatformDiscount' + el.oilCode] = el.monthSumPlatformDiscount || 0;
          obj[el.sellerId] = tmpObj;
        } else {
          var _extraDiscount = NP.round(NP.times(el.monthNums, NP.minus(el.monthGoodsOriginal, el.monthGoodsPrice)), 2);

          obj[el.sellerId]['sellerId'] = el.sellerId;
          obj[el.sellerId]['dayNums'] = NP.round(NP.plus(obj[el.sellerId]['dayNums'], el.monthNums), 2);
          obj[el.sellerId]['daySumDiscount'] = NP.round(NP.plus(obj[el.sellerId]['daySumDiscount'], el.monthSumUserDiscount, el.monthSumSvcDiscount, el.monthSumPlatformDiscount, _extraDiscount), 2);
          obj[el.sellerId]['dayDiffDiscountPrice'] = obj[el.sellerId]['dayNums'] === 0 ? 0 : NP.round(NP.divide(obj[el.sellerId]['daySumDiscount'], obj[el.sellerId]['dayNums']), 2);
          obj[el.sellerId]['dayNums' + el.oilCode] = el.monthNums;
          obj[el.sellerId]['daySumDiscount' + el.oilCode] = NP.round(NP.plus(el.monthSumUserDiscount, el.monthSumSvcDiscount, el.monthSumPlatformDiscount, _extraDiscount), 2);
          obj[el.sellerId]['dayDiffDiscountPrice' + el.oilCode] = el.monthNums === 0 ? 0 : NP.round(NP.divide(NP.plus(el.monthSumUserDiscount, el.monthSumSvcDiscount, el.monthSumPlatformDiscount, _extraDiscount), el.monthNums), 2);
          obj[el.sellerId]['daySumExtraDiscount' + el.oilCode] = _extraDiscount || 0;
          obj[el.sellerId]['daySumUserDiscount' + el.oilCode] = el.monthSumUserDiscount || 0;
          obj[el.sellerId]['daySumSvcDiscount' + el.oilCode] = el.monthSumSvcDiscount || 0;
          obj[el.sellerId]['daySumPlatformDiscount' + el.oilCode] = el.monthSumPlatformDiscount || 0;
        }
      });
      return obj;
    },
    exportExcel: function exportExcel(tableArr, excelName) {
      var _this4 = this;

      if (this.sheetUnLoadCount > 0) {
        _Message({
          message: '请查询核对过后进行下载',
          type: 'error',
          duration: 3 * 1000
        });

        return;
      }

      if (this.stationDailyDiscountData.length === 0) {
        _Message({
          message: '无有效数据，请查询后下载',
          type: 'error',
          duration: 3 * 1000
        });

        return;
      }

      if (tableArr.length < 1) {
        _Message({
          message: '导出 sheet 为空',
          type: 'error',
          duration: 3 * 1000
        });

        return;
      }

      this.downloadLoading = true;
      import('@/utils/Export2Excel').then(function (excel) {
        excel.export_table_to_excel(tableArr, moment(_this4.datePickerValue[0]).format('YYYY年MM月DD日') + ' ~ ' + moment(_this4.datePickerValue[1]).format('YYYY年MM月DD日') + excelName);
        _this4.downloadLoading = false;
      }).catch(function () {
        _this4.downloadLoading = false;
      });
    }
  }
};